define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * 波纹编辑模式。
     *
     * @exports EnumRippleEditMode
     * 
     * @see Ripple#editMode
     */
    var EnumRippleEditMode = {
        /**
         * 展示模式。
         * @type {Number}
         * @constant
         */
        SHOW: 0,

        /**
         * 编辑模式。
         * @type {Number}
         * @constant
         */
        CREATE: 1
    }
    freezeObject(EnumRippleEditMode)
    /**
     * 反向查找对齐方式的名称。
     * 
     * @param {Number} value 对齐方式的数值。
     * @returns {String} 对齐方式的名称。
     */
    function getName(value) {
        for (var key in EnumRippleEditMode) {
            if (EnumRippleEditMode.hasOwnProperty(key) && EnumRippleEditMode[key] === value) {
                return key
            }
        }
        return undefined
    }
    return {
        SHOW: 0,
        CREATE: 1,
        getName: getName
    }
})